import { toast } from 'react-toastify';

import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppMutation, useInvalidateQueries } from '../../../../hooks/index';
import { ApiService } from '../../../../services/index';
import { Perk } from '../perks.types';

export const useActivatePerk = () => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.PERKS);
  const body: Partial<Pick<Perk, 'active'>> = { active: true };
  const { mutate: activatePerk, isPending } = useAppMutation([QueryKey.PERKS, QueryKey.PATCH], {
    mutationFn: ({ id }: { id: string }) =>
      ApiService.patch(
        {
          endpoint: BackendRoute.PERKS,
          routePath: [id],
        },
        { regularBackend: true, body },
      ),
    onSuccess: (_, { id }) => {
      invalidateQuery(id);
      toast.success('Perk activated and published');
    },
    defaultErrorHandling: false,
    onError: () => {
      toast.error('Couldn’t activate. Please try again');
    },
  });

  return {
    isPending,
    activatePerk,
  };
};
